




























































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import MyForm from '@/mixins/form';
import TsUpload from '@/components/upload.vue';

import MyConfig from '@/config';

@Component({
  components: {
    TsUpload,
  },
})
export default class extends Mixins(MyForm) {
  apiserver: string = MyConfig.casapi;

  headers: any = {
    Authorization: window.localStorage.getItem('token'),
  };

  @Prop() stadiumId!: number;

  fileList: any[] = [];

  previewVisible = false;

  previewImage = '';

  imageUrl = '';

  loading = false;

  handleCancel1() {
    this.previewVisible = false;
  }

  handleChange(info: any) {
    if (info.file.status === 'uploading') {
      this.loading = true;
      return;
    }
    if (info.file.status === 'done') {
      // console.log(info)
      this.imageUrl = this.renderImage(info.file.response.Data);
      this.loading = false;
    }
  }

  handleChange1({ fileList }: any) {
    // this.fileList = fileList
  }

  handlePreview(file: any) {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  }

  handleRemove() {
    return new Promise((resolve) => {
      this.$confirm({
        title: '确认信息',
        content: '你确定要删除吗？',
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '确定要提交吗1？',
          onOk: async () => {
            const values: any = {};
            // console.log(fieldValues)
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const val: any = _.get(fieldValues, [key]);
                // console.log(key)
                // console.log(val)
                if (val) {
                  // console.log(key)
                  // console.log(val)
                  if (key === 'media') {
                    let media = '';
                    // const arr: any[] = val.fileList
                    for (const obj of val) {
                      media += `${obj.response.Data},`;
                    }

                    _.set(values, ['media'], _.trim(media, ','));
                  } else {
                    _.set(values, ['thumbnails'], val);
                  }
                }
              }
            }
            // console.log(values)
            // return
            const res = await this.$store.dispatch('stadium/saveMedia', {
              stadium_id: this.stadiumId,
              ...values,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
              // this.loadData1()
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }

  async loadData1() {
    const res = await this.$store.dispatch('stadium/getMedia', {
      stadium_id: this.stadiumId,
    });
    // console.log(res)
    if (res && res.Data && res.Data !== '{}') {
      this.formData.media_status = res.Data.media_status;
      // this.formData = res.Data
      if (res.Data.thumbnails) {
        // this.form.setFieldsValue({
        //   thumbnails: res.Data.thumbnails
        // })
        this.formData.thumbnails = res.Data.thumbnails;
        this.imageUrl = this.renderImage(res.Data.thumbnails);
      }

      if (res.Data.media) {
        const media: any[] = [];
        res.Data.media
          .split(',')
          .forEach((element: any, index: number, array: any) => {
            // console.log('1')
            media.push({
              uid: `${Math.random()}`,
              name: `${Math.random()}`,
              status: 'done',
              url: this.renderImage(element),
              response: { Data: element },
            });
          });

        this.form.setFieldsValue({
          media,
        });
      }
    }
  }

  normFile(e: any) {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  }

  mounted() {
    this.spinLoading = true;
    this.loadData1();
    this.spinLoading = false;
  }

  async setMediaStatus(val: any, id: number) {
    this.$confirm({
      title: '确认信息',
      content: `您确定要${
        val === true ? '审核通过' : '审核不通过'
      }该场馆的轮播图和缩略图吗？`,
      onOk: async () => {
        // if (!this.checkPermission('admin-stadiums-edit')) {
        //   this.$message.warning('没有权限')
        //   return
        // }
        const res = await this.$store.dispatch('stadium/mediastatus', {
          id,
          val,
        });
        // console.log(res)
        if (res && res.Message && res.Message === 'success') {
          if (val === true) {
            this.formData.media_status = 1;
          } else {
            this.formData.media_status = 0;
          }
          this.$message.success('操作成功');
          this.loadData1();
        } else {
          this.$message.error('操作失败');
        }
      },
    });
  }
}
